var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import anyTrait from "../Decorators/anyTrait";
import primitiveArrayTrait from "../Decorators/primitiveArrayTrait";
import primitiveTrait from "../Decorators/primitiveTrait";
import mixTraits from "../mixTraits";
import TimeFilterTraits from "./TimeFilterTraits";
let DiffableTraits = (_dec = primitiveArrayTrait({
  type: "string",
  name: "Available diff styles",
  description: "List of styles that can be used for computing difference image"
}), _dec2 = primitiveTrait({
  type: "boolean",
  name: "Show diff image",
  description: "True if currently showing diff image"
}), _dec3 = primitiveTrait({
  type: "string",
  name: "First diff date",
  description: "The first date to use to compute the difference image"
}), _dec4 = primitiveTrait({
  type: "string",
  name: "Second diff date",
  description: "The second date to use to compute the difference image"
}), _dec5 = primitiveTrait({
  type: "string",
  name: "Diff style ID",
  description: "The ID of the style used to compute the difference image"
}), _dec6 = anyTrait({
  name: "Difference item properties",
  description: "Additional properties to set on the difference output item."
}), _class = class DiffableTraits extends mixTraits(TimeFilterTraits) {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "availableDiffStyles", _descriptor, this);
    _initializerDefineProperty(this, "isShowingDiff", _descriptor2, this);
    _initializerDefineProperty(this, "firstDiffDate", _descriptor3, this);
    _initializerDefineProperty(this, "secondDiffDate", _descriptor4, this);
    _initializerDefineProperty(this, "diffStyleId", _descriptor5, this);
    _initializerDefineProperty(this, "diffItemProperties", _descriptor6, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "availableDiffStyles", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "isShowingDiff", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "firstDiffDate", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "secondDiffDate", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "diffStyleId", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "diffItemProperties", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { DiffableTraits as default };